import {isRoomType, isBoardType} from '@/utils/inviaType';

export type RoomType = {
  adultsCount: number;
  childrenAges: Array<number>;
  roomTypes: Array<string>;
  boardTypes: Array<string>;
};

export const Room = {
  create({
    adultsCount = 0,
    childrenAges = [],
    roomTypes = [],
    boardTypes = [],
  }: Partial<RoomType>): RoomType {
    // using defineProperties here because we don't want methods to show up in iteration
    return Object.defineProperties(
      {
        adultsCount,
        childrenAges,
        roomTypes,
        boardTypes,
      },
      {
        toString: {
          value() {
            return [
              ...Array.from({length: adultsCount}, () => 'A'),
              ...childrenAges,
              ...roomTypes,
              ...boardTypes,
            ].join(',');
          },
        },
      }
    );
  },
  fromString(roomString: string): RoomType {
    const {adultsCount, childrenAges, roomTypes, boardTypes} = roomString
      .split(',')
      .map((v) => v.trim())
      .reduce<RoomType>(
        (room, value) => {
          const valueAsInt = Number.parseInt(value, 10);
          if (value === 'A') {
            room.adultsCount += 1;
          } else if (!Number.isNaN(valueAsInt)) {
            room.childrenAges.push(valueAsInt);
          } else if (isRoomType(value)) {
            room.roomTypes.push(value);
          } else if (isBoardType(value)) {
            room.boardTypes.push(value);
          }
          return room;
        },
        {
          adultsCount: 0,
          childrenAges: [],
          roomTypes: [],
          boardTypes: [],
        }
      );

    return Room.create({
      adultsCount,
      childrenAges,
      roomTypes,
      boardTypes,
    });
  },
};
